(() => {
  function initialize() {
    const root = document.getElementById('veigo-original-story');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const story = root.querySelector('.scroll-story');
    const stage = root.querySelector('.story-stage');
    const chapters = [...root.querySelectorAll('.chapter')];
    const names = ['The Original', 'Steel at heart', 'Open for good food', 'Colour your day', 'Meet the family'];
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const clamp = n => Math.max(0, Math.min(1, n));
    const ease = n => n * n * (3 - 2 * n);
    let frame = 0;
    const lifecycle = new AbortController();
    function draw() {
      frame = 0;
      const reduced = media.matches;
      const rect = story.getBoundingClientRect();
      const progress = clamp(-rect.top / Math.max(1, rect.height - stage.clientHeight));
      const active = Math.min(4, Math.floor(progress * 5));
      const local = index => reduced ? .45 : clamp((progress - index / 5) * 5);
      chapters.forEach((chapter,index) => {
        const enter = index === 0 ? 1 : ease(clamp((progress - index / 5 + .025) / .05));
        const leave = index === 4 ? 1 : 1 - ease(clamp((progress - (index + 1) / 5 + .025) / .05));
        chapter.style.opacity = reduced ? '1' : String(Math.min(enter,leave));
        chapter.style.zIndex = String(index + 1);
        chapter.setAttribute('aria-hidden', String(!reduced && active !== index));
      });
      root.querySelectorAll('[data-motion]').forEach(el => {
        const [index,from,to,sf,st] = el.dataset.motion.split(',').map(Number);
        const t = ease(local(index));
        el.style.transform = reduced ? 'none' : `translateY(${(1-t)*5-2}%) rotate(${from+(to-from)*t}deg) scale(${sf+(st-sf)*t})`;
      });
      root.querySelectorAll('[data-fan]').forEach(el => {
        const [index,x,rotation] = el.dataset.fan.split(',').map(Number);
        const t = local(3);
        el.style.transform = `translate(${x+(index-1)*(1-t)*25}%,${index===1?-8:8+(1-t)*20}%) rotate(${rotation*(.5+t*.5)}deg)`;
      });
      const family = local(4);
      root.querySelector('.family-jumbo').style.transform = reduced ? 'none' : `translateY(${(1-family)*18}%) rotate(${-7+family*7}deg)`;
      root.querySelector('.family-medium').style.transform = reduced ? 'none' : `translate(${-20*(1-family)}%,${16*(1-family)}%) rotate(-10deg)`;
      root.querySelector('.family-round').style.transform = reduced ? 'none' : `translate(${25*(1-family)}%,${20*(1-family)}%) rotate(9deg)`;
      root.querySelector('[data-chapter-number]').textContent = String(active+1).padStart(2,'0');
      root.querySelector('[data-chapter-title]').textContent = names[active];
      root.querySelector('[data-slot="progress-indicator"]').style.transform = `scaleX(${progress})`;
    }
    const queue = () => { if (!frame) frame = requestAnimationFrame(draw); };
    window.addEventListener('scroll',queue,{passive:true,signal:lifecycle.signal});
    window.addEventListener('resize',queue,{signal:lifecycle.signal});
    media.addEventListener('change',queue,{signal:lifecycle.signal});
    draw();

    let request;
    let revision = 0;
    let pending = false;
    const status = root.querySelector('[data-picker-status]');
    root.addEventListener('change', async event => {
      if (!event.target.matches('[data-option-position]')) return;
      const picker = event.target.closest('[data-original-picker]');
      if (!picker) return;
      const focusedId = event.target.id;
      const currentRevision = ++revision;
      request?.abort(); request = new AbortController(); pending = true;
      const values = [...picker.querySelectorAll('input[data-option-position]:checked,select[data-option-position]')]
        .sort((a,b) => Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(el => el.value);
      const url = new URL(picker.dataset.productUrl, location.origin);
      url.searchParams.set('option_values', values.join(','));
      const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id',previewTheme);
      const productLink = picker.querySelector('.picker-product-link');
      productLink.href = url.href;
      url.searchParams.set('section_id','veigo-original-picker');
      picker.setAttribute('aria-busy','true');
      picker.querySelector('button[type="submit"]').disabled = true;
      picker.querySelector('input[name="id"]').disabled = true;
      status.textContent = 'Updating your size, colour and pack…';
      try {
        const response = await fetch(url,{credentials:'same-origin',signal:request.signal});
        if (!response.ok) throw new Error('Variant response failed');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const updated = html.querySelector('[data-original-picker]');
        if (!updated) throw new Error('Missing variant response');
        if (currentRevision !== revision) return;
        picker.replaceWith(updated);
        pending = false;
        const newFocus = document.getElementById(focusedId);
        newFocus?.focus({preventScroll:true});
        status.textContent = [...updated.querySelector('.picker-price-row').children].map(el => el.textContent.trim()).join(' · ');
      } catch (error) {
        if (error.name === 'AbortError' || currentRevision !== revision) return;
        picker.removeAttribute('aria-busy');
        status.textContent = 'We couldn’t refresh this selection. Please use “View this selection on the product page” below, or try another option.';
      }
    },{signal:lifecycle.signal});
    root.addEventListener('submit',event => {
      const form = event.target;
      if (form.id !== 'veigo-original-cart') return;
      const id = form.querySelector('input[name="id"]');
      if (pending || !id || id.disabled || !id.value) event.preventDefault();
    },{signal:lifecycle.signal});
    document.addEventListener('shopify:section:unload',event => {
      if (event.target.contains(root)) { lifecycle.abort(); request?.abort(); cancelAnimationFrame(frame); }
    },{signal:lifecycle.signal});
  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
